module.exports = __webpack_public_path__ + "static/media/losos.b220e2da.png";